export default __webpack_public_path__ + "static/media/Anagha Narayanan.7f960e5f.jpg";